import { withProps } from "recompose";

export const withInitialCollectionDate = withProps(({ collection }) => {
  return {
    initialCollectionDate: collection.collectionDate,
  };
});
